"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { CheckmarkCircle } from "@crehana/compass.icons.fill/v2/checkmark-circle";
import { cn } from "../utils.js";
const TimePickerColumn = ({ items, selectedValue, onSelect, label })=>{
    const listRef = useRef(null);
    const itemRefs = useRef(new Map());
    const initialValueRef = useRef(selectedValue);
    useEffect(()=>{
        if (!initialValueRef.current) return;
        const selectedEl = itemRefs.current.get(initialValueRef.current);
        if (selectedEl && listRef.current) {
            const listRect = listRef.current.getBoundingClientRect();
            const itemRect = selectedEl.getBoundingClientRect();
            const scrollTop = selectedEl.offsetTop - listRef.current.offsetTop - listRect.height / 2 + itemRect.height / 2;
            listRef.current.scrollTop = Math.max(0, scrollTop);
        }
    }, []);
    return /*#__PURE__*/ jsx("div", {
        ref: listRef,
        role: "listbox",
        "aria-label": label,
        className: "tw-flex tw-flex-col tw-overflow-y-auto tw-h-24 tw-w-10 tw-shrink-0 tw-scrollbar-thin",
        children: items.map((item)=>{
            const isSelected = item === selectedValue;
            return /*#__PURE__*/ jsxs("button", {
                ref: (el)=>{
                    if (el) itemRefs.current.set(item, el);
                    else itemRefs.current.delete(item);
                },
                role: "option",
                "aria-selected": isSelected,
                type: "button",
                className: cn('tw-w-10.4 tw-h-4.8 tw-px-2.4 tw-py-1.2 tw-flex tw-items-center tw-cursor-pointer tw-outline-none tw-shrink-0', 'tw-cds-font-body-02', 'hover:tw-cds-bg-layer-02', 'focus-visible:tw-ring-2 focus-visible:tw-ring-primary-light-500', isSelected && 'tw-cds-bg-layer-02 tw-gap-1.2'),
                onClick: ()=>onSelect(item),
                children: [
                    /*#__PURE__*/ jsx("span", {
                        children: item
                    }),
                    isSelected && /*#__PURE__*/ jsx(CheckmarkCircle, {
                        size: 20,
                        className: "tw-text-[var(--cds-icon-color-success)] tw-shrink-0"
                    })
                ]
            }, item);
        })
    });
};
export { TimePickerColumn };
